import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FileManagerService } from '../../services/file-manager.service';
import { UploadSourcesNamming, ViewModes } from '../../models';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { AvatarComponent } from 'src/app/shared/components/avatar/avatar.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { BytesToSizePipe } from 'src/app/shared/pipes/bytes-size.pipe';
import { FileCategoryColorPipe } from 'src/app/shared/pipes/file-category-color.pipe';
import { SafePipe } from 'src/app/shared/pipes/safe.pipe';
import { FilenamePipe } from 'src/app/shared/pipes/filename.pipe';
import { MomentPipe } from 'src/app/shared/pipes/moment.pipe';
import { UsernamePipe } from 'src/app/shared/pipes/username.pipe';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'app-file-manager-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzCheckboxModule,
    NzIconModule,
    NzSpinModule,
    NzToolTipModule,
    NzSelectModule,
    NzInputModule,
    NzButtonModule,
    NzPopconfirmModule,
    AvatarComponent,
    BytesToSizePipe,
    FileCategoryColorPipe,
    SafePipe,
    FilenamePipe,
    MomentPipe,
    UsernamePipe,
  ],
})
export class FileManagerCardComponent {
  readonly fileManagerService = inject(FileManagerService);
  @Input('mode') mode: 'private' | 'public' = 'private';
  @Input('selectable') selectable = true;
  @Input('showActions') showActions = false;
  @Input('showAvatar') showAvatar = false;
  @Input('showSource') showSource = false;
  @Input('clickable') clickable = true;
  @Input('previewMode') previewMode = false;
  @Input('forceHideTagging') forceHideTagging = false;
  @Input('actions') actions = {
    tagging: {
      allow: false,
      visible: false,
    },
    remove: {
      allow: false,
    },
    update: {
      allow: false,
    },
    checkbox: {
      allow: false,
    },
  };
  @Input('borderless') borderless = false;
  @Input('backgroundless') backgroundless = false;
  @Input('view') view: ViewModes = 'medium';
  @Input('file') file;
  @Output('clicked') clicked = new EventEmitter();
  @Output('onRemove') onRemove = new EventEmitter();
  @Output('onUpdate') onUpdate = new EventEmitter();
  visibility = {
    tagging: false,
  };
  readonly UploadSourcesNamming = UploadSourcesNamming;

  preview(file): void {
    if (
      this.clickable &&
      this.file.status !== 'failed' &&
      this.file.status !== 'loading'
    ) {
      this.clicked.emit(file);
    }
  }

  toggleTagging() {
    this.file.tagging_visible = !this.file.tagging_visible;
  }

  checkboxChanged(file): void {
    this.fileManagerService.toggleSelection(file);
  }
}
